<template>
  <v-app>
    <v-content style="background-color:#446BC1">
      <v-row class="mt-10">
        <v-col lg="3" xs="1" />
        <v-col lg="6" xs="10" style="color:white" class="pa-4">
          <img src="./assets/gemnote_logo.svg" height="80" class="mb-8"/>

          <p class="body1">
            <b>GemNote</b> is created by UnrealisticWorks - a boutique design and development studio based in Berlin, Germany.
          </p>

          <p class="body1">
            It is made to be a helpful asistant for gemstone lovers, jewellry
            designers and hobbyists, providing them gemstone knowledge, asisting
            their design and sourcing processes.
          </p>
          <p class="body1">
            We would love to hear your feedback: what you like or don’t like,
            what features do you wish to have. Drop us a mail at
            <b
              ><a
                :href="'mailto:unrealisticworks@gmail.com'"
                target="_blank"
                style="color:#F5913D"
                >UnrealisticWorks[at]gmail.com</a
              ></b
            >
          </p>

          <p class="mt-4 body1">
            If you havn’t tried GemNote, it’s free and you can find it in both
            Google Play store and Apple App store.
          </p>

          <div class="d-flex align-center justify-start">
           <a href="https://apps.apple.com/us/app/gemnote/id1510924024?ls=1" target="_blank"> <img src="./assets/apple_store.svg" height="55" /></a>
            <a href="https://play.google.com/store/apps/details?id=com.unrealisticworks.gemnote" target="_blank"><img src="./assets/play_store.png" height="80" /></a>
          </div>
        </v-col>
        <v-col lg="3" xs="1" />
      </v-row>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
